<section class="not-found-state" [dir]="isRtl ? 'rtl' : 'ltr'">
  <div class="container px-lg-0 text-center py-5">
    @if (titleKey) {
    @if (isUnified) {
    <h1 class="uc-page-title uc-display-sm uc-semibold mb-3" [translate]="titleKey"></h1>
    } @else {
    <h3 class="mb-3" [translate]="titleKey"></h3>
    }
    }
    <p class="uc-text-md text-muted mb-4" [translate]="messageKey"></p>
    <a class="btn btn-show-courses shadow-none d-inline-flex align-items-center justify-content-center"
       [routerLink]="link" [queryParams]="queryParams" [translate]="linkKey"></a>
  </div>
</section>
